import React, { useEffect, useState } from "react";
import {
  DocumentData,
  QueryDocumentSnapshot,
  QuerySnapshot,
  collection,
  getDocs,
  orderBy,
  getFirestore,
  onSnapshot,
  query,
  where,
} from "firebase/firestore";
import styles from "./Connection.module.css";

import { ConnectionRequestPost } from "../Types/connectionRequests";
import { NewUserProfileType } from "../Types/userProfile";
import FromMeRequestsPost from "./FromMeRequestsPost";
import { app, auth } from "../lib/firebase";
import "../lib/RequireUser/index.css";

import { getStorage, ref } from "firebase/storage";

const db = getFirestore(app);

function FromMeRequestsPre() {
  const tempUser = localStorage.getItem("userUID");
  console.log("in addConnections and userUID = ", tempUser);

  const [userProfilesAll, setUserProfilesAll] = useState<NewUserProfileType[]>(
    []
  );
  const [thisUserProfile, setThisUserProfile] = useState<NewUserProfileType[]>(
    []
  );
  const [connectionRequestsAll, setConnectionRequestsAll] = useState<
    ConnectionRequestPost[]
  >([]);

  const [isLoading, setIsLoading] = useState(true); // New: track loading state

  //Load all connection requests
  useEffect(() => {
    //Query all connectionRequests
    const qConnectionRequests = query(
      collection(db, "connectionRequests")
      //where("requestToEmail", "==", thisUserProfile[0].userEmail),
      //orderBy("userProfileName", "desc")
    );
    const unsubscribe = onSnapshot(qConnectionRequests, (snapshot) => {
      const profiles = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      setConnectionRequestsAll(profiles);
      setIsLoading(false); // Done loading regardless of result
    });
    return () => unsubscribe();
  }, []);

  //query all userProfile and output only this user
  const qUser = query(
    collection(db, "userProfiles"),
    where("userUID", "==", tempUser)
  );

  //load only this user's profile
  useEffect(
    () =>
      onSnapshot(qUser, (snapshot) => {
        setThisUserProfile(
          snapshot.docs.map((doc) => {
            return {
              id: doc.id,
              ...doc.data(),
            };
          })
        );
      }),
    []
  );

  //query all userProfile but do not include this user
  const qUsersAll = query(
    collection(db, "userProfiles"),
    where("userUID", "!=", tempUser),
    orderBy("userProfileName", "desc")
  );

  useEffect(
    () =>
      onSnapshot(qUsersAll, (snapshot) => {
        setUserProfilesAll(
          snapshot.docs.map((doc) => {
            return {
              id: doc.id,
              ...doc.data(),
            };
          })
        );
      }),
    []
  );

  //Create a temp user profile array
  let userProfiles = [];
  let profileLength = [];

  //userProfilesAll.length;

  let i = 0,
    j = 0,
    l = 0;
  let requestsArrayOK = 1;
  let userConnectionsOK = 1;

  console.log("length of userProfilesAll = ", userProfilesAll.length);
  console.log("length of thisUserProfile = ", thisUserProfile.length);
  console.log("length of requests = ", connectionRequestsAll.length);

  if (
    userProfilesAll.length != 0 &&
    thisUserProfile.length != 0 &&
    connectionRequestsAll.length != 0
  ) {
    for (i = 0; i < connectionRequestsAll.length; i++) {
      for (j = 0; j < userProfilesAll.length; j++) {
        if (
          connectionRequestsAll[i].requestFromEmail ===
            thisUserProfile[0].userEmail &&
          connectionRequestsAll[i].requestToEmail ===
            userProfilesAll[j].userEmail
        ) {
          userProfiles[l] = userProfilesAll[j];
          //console.log(" profile copied for i = ", i);
          l++;
          break;
          //console.log(" requestsArrayOK = 0");
        }
      }
    }
  }
  console.log("in pre before and userProfiles = ", userProfiles);
  console.log("in pre before and userProfiles.length = ", userProfiles.length);
  console.log("in pre and isLoading = ", isLoading);
  console.log("connectionRequestsAll.length = ", connectionRequestsAll.length);
  console.log("userProfiles = ", userProfiles);

  if (isLoading) {
    return <div>Loading...</div>;
  }

  if (
    !isLoading &&
    connectionRequestsAll.length != 0 &&
    userProfiles.length === 0
  ) {
    return (
      <div>
        <h3 style={{ marginLeft: 50, marginTop: 40, marginBottom: -20 }}>
          &nbsp; No records found
        </h3>
        <button
          style={{ marginLeft: 250, marginTop: -60 }}
          className={styles.userButtons}
          onClick={() => history.back()}
        >
          Return
        </button>
      </div>
    );
  }

  return (
    <div>
      {userProfiles.map((userProfiles) => (
        <FromMeRequestsPost key={userProfiles.id} userProfile={userProfiles} />
      ))}
    </div>
  );
}

export default FromMeRequestsPre;
